import type { ReactNode } from 'react'
import { OtherWaysToGive } from './OtherWaysToGive'
import './donate.css'

/**
 * The public Give page's frame: what the page is about, and the other ways to
 * give, beside the flow where the page has room for both, and stacked above
 * and below it where it does not.
 *
 * The flow keeps its own measure at every width. It is the column every
 * question, answer and card inside it asks, so the page around it may widen
 * without a folded answer or the card step laying itself out any differently.
 */
export function GiveFrame({
  head,
  other,
  children,
}: {
  /** The page's heading, and whatever it says before the flow. Absent while
   *  what it would name is still loading. */
  head: ReactNode
  other: Array<{ label: string; details: string[] }>
  children: ReactNode
}) {
  return (
    <div className="give">
      <div className="give__layout">
        {head ? <div className="give__head">{head}</div> : null}
        <div className="give__flow">{children}</div>
        <OtherWaysToGive items={other} />
      </div>
    </div>
  )
}

/**
 * A payment that is done, thanked across the page: the flow it replaces has
 * nothing left beside it to explain.
 */
export function GiveDone({ children }: { children: ReactNode }) {
  return <div className="give give--done">{children}</div>
}
